// Importing Tier badges
import Tier1 from "../assets/svg/badge/1tier.svg";
import Tier2 from "../assets/svg/badge/2tier.svg";
import Tier3 from "../assets/svg/badge/3tier.svg";
import Tier4 from "../assets/svg/badge/4tier.svg";
import luna from "../assets/svg/badge/luna.svg";

// Importing Ribbon SVGs
import Ribbons_BASIC3 from "../assets/svg/badge/Ribbons_BASIC3_FULL.svg";
import Ribbons_BASIC4 from "../assets/svg/badge/Ribbons_BASIC4_FULL.svg";
import Ribbons_Classic3 from "../assets/svg/badge/Ribbons_Classic3_FULL.svg";
import Ribbons_Classic4 from "../assets/svg/badge/Ribbons_Classic4_FULL.svg";
import Ribbons_Double3 from "../assets/svg/badge/Ribbons_Double3_FULL.svg";
import Ribbons_Double4 from "../assets/svg/badge/Ribbons_Double4_FULL.svg";
import Ribbons_Elegant7 from "../assets/svg/badge/Ribbons_Elegant7_FULL.svg";
import Ribbons_Elegant8 from "../assets/svg/badge/Ribbons_Elegant8_FULL.svg";
import Ribbons_Glamor7 from "../assets/svg/badge/Ribbons_Glamor7_FULL.svg";
import Ribbons_Glamor8 from "../assets/svg/badge/Ribbons_Glamor8_FULL.svg";
import Ribbons_HyperNova7 from "../assets/svg/badge/Ribbons_HyperNova7_FULL.svg";
import Ribbons_HyperNova8 from "../assets/svg/badge/Ribbons_HyperNova8_FULL.svg";
import Ribbons_Nebula7 from "../assets/svg/badge/Ribbons_Nebula7_FULL.svg";
import Ribbons_Nebula8 from "../assets/svg/badge/Ribbons_Nebula8_FULL.svg";
import Ribbons_Nova5 from "../assets/svg/badge/Ribbons_Nova5_FULL.svg";
import Ribbons_Nova6 from "../assets/svg/badge/Ribbons_Nova6_FULL.svg";
import Ribbons_Star3 from "../assets/svg/badge/Ribbons_Star3_FULL.svg";
import Ribbons_Star4 from "../assets/svg/badge/Ribbons_Star4_FULL.svg";
import Ribbons_SuperNova7 from "../assets/svg/badge/Ribbons_SuperNova7_FULL.svg";

export const cardData = [
  // {
  //     imageSrc: Tier1,
  //     alt: "tier1",
  //     label: "tier1",
  //     name: "1 Tier Rosette 95mm x 250mm",
  //     active: true,
  //     svgContent: null,
  // },
  // {
  //     imageSrc: Tier2,
  //     alt: "tier2",
  //     label: "tier2",
  //     name: "2 Tier Rosette 110mm x 250mm",
  //     active: false,
  //     svgContent: null,
  // },
  // {
  //     imageSrc: Tier3,
  //     alt: "tier3",
  //     label: "tier3",
  //     name: "3 Tier Rosette 125mm x 280mm",
  //     active: false,
  //     svgContent: null,
  // },
  // {
  //     imageSrc: Tier4,
  //     alt: "tier4",
  //     label: "tier4",
  //     name: "4 Tier Rosette 135mm x 320mm",
  //     active: false,
  //     svgContent: null,
  // },
  // {
  //     imageSrc: luna,
  //     alt: "luna",
  //     label: "luna",
  //     name: "Luna Rosette 135mm x 320mm",
  //     active: false,
  //     svgContent: null,
  // },
  {
    imageSrc: Ribbons_BASIC3,
    alt: "ribbons_BASIC3",
    label: "ribbons_BASIC3",
    name: "BASIC 3 Ribbon",
    size: "small",
    active: true,
    svgContent: null,
  },
  {
    imageSrc: Ribbons_BASIC4,
    alt: "ribbons_BASIC4",
    label: "ribbons_BASIC4",
    name: "BASIC 4 Ribbon",
    size: "small",
    active: false,
    svgContent: null,
  },
  {
    imageSrc: Ribbons_Classic3,
    alt: "ribbons_Classic3",
    label: "ribbons_Classic3",
    name: "Classic 3 Ribbon",
    size: "medium",
    active: false,
    svgContent: null,
  },
  {
    imageSrc: Ribbons_Classic4,
    alt: "ribbons_Classic4",
    label: "ribbons_Classic4",
    name: "Classic 4 Ribbon",
    size: "medium",
    active: false,
    svgContent: null,
  },
  {
    imageSrc: Ribbons_Double3,
    alt: "ribbons_Double3",
    label: "ribbons_Double3",
    name: "Double 3 Ribbon",
    size: "small",
    active: false,
    svgContent: null,
  },
  {
    imageSrc: Ribbons_Double4,
    alt: "ribbons_Double4",
    label: "ribbons_Double4",
    name: "Double 4 Ribbon",
    size: "small",
    active: false,
    svgContent: null,
  },
  {
    imageSrc: Ribbons_Elegant7,
    alt: "ribbons_Elegant7",
    label: "Ribbons Elegant7",
    name: "Elegant 7 Ribbon",
    size: "xl",
    active: false,
    svgContent: null,
  },
  {
    imageSrc: Ribbons_Elegant8,
    alt: "ribbons_Elegant8",
    label: "Ribbons Elegant8",
    name: "Elegant 8 Ribbon",
    size: "xl",
    active: false,
    svgContent: null,
  },
  {
    imageSrc: Ribbons_Glamor7,
    alt: "ribbons_Glamor7",
    label: "Ribbons Glamor7",
    name: "Glamor 7 Ribbon",
    size: "xl",
    active: false,
    svgContent: null,
  },
  {
    imageSrc: Ribbons_Glamor8,
    alt: "ribbons_Glamor8",
    label: "Ribbons Glamor8",
    name: "Glamor 8 Ribbon",
    size: "xl",
    active: false,
    svgContent: null,
  },
  {
    imageSrc: Ribbons_HyperNova7,
    alt: "ribbons_HyperNova7",
    label: "Ribbons HyperNova7",
    name: "HyperNova 7 Ribbon",
    size: "xl",
    active: false,
    svgContent: null,
  },
  {
    imageSrc: Ribbons_HyperNova8,
    alt: "ribbons_HyperNova8",
    label: "Ribbons HyperNova8",
    name: "HyperNova 8 Ribbon",
    size: "xl",
    active: false,
    svgContent: null,
  },
  {
    imageSrc: Ribbons_Nebula7,
    alt: "ribbons_Nebula7",
    label: "Ribbons Nebula7",
    name: "Nebula 7 Ribbon",
    size: "large",
    active: false,
    svgContent: null,
  },
  {
    imageSrc: Ribbons_Nebula8,
    alt: "ribbons_Nebula8",
    label: "Ribbons Nebula8",
    name: "Nebula 8 Ribbon",
    size: "large",
    active: false,
    svgContent: null,
  },
  {
    imageSrc: Ribbons_Nova5,
    alt: "ribbons_Nova5",
    label: "Ribbons Nova5",
    name: "Nova 5 Ribbon",
    size: "large",
    active: false,
    svgContent: null,
  },
  {
    imageSrc: Ribbons_Nova6,
    alt: "ribbons_Nova6",
    label: "Ribbons Nova6",
    name: "Nova 6 Ribbon",
    size: "large",
    active: false,
    svgContent: null,
  },
  {
    imageSrc: Ribbons_Star3,
    alt: "ribbons_Star3",
    label: "Ribbons Star3",
    name: "Star 3 Ribbon",
    size: "medium",
    active: false,
    svgContent: null,
  },
  {
    imageSrc: Ribbons_Star4,
    alt: "ribbons_Star4",
    label: "Ribbons Star4",
    name: "Star 4 Ribbon",
    size: "medium",
    active: false,
    svgContent: null,
  },
  {
    imageSrc: Ribbons_SuperNova7,
    alt: "ribbons_SuperNova7",
    label: "Ribbons SuperNova7",
    name: "SuperNova 7 Ribbon",
    size: "xl",
    active: false,
    svgContent: null,
  },
];
